import { ComplexEnumItem } from '../../utils/complexEnum/ComplexEnumItem'
import { CIMSModuleItem } from '../CIMSModule/CIMSModuleItem'
import { BasicPermissionItem } from '../permission'

export class RoleTemplateItem<
  ID extends Lowercase<string>,
  Name extends string,
  Description extends string,
  ModuleID extends Lowercase<string>,
  ModuleName extends string
> extends ComplexEnumItem<ID> {
  readonly name: Name
  readonly description: Description | undefined
  readonly module: CIMSModuleItem<ModuleID, ModuleName>
  readonly permissionItems: BasicPermissionItem[]
  /**
   * Role entities don't have permission ids hard-typed right now
   *
   * this property makes that easier to deal with
   */
  readonly permissions: string[]

  constructor({
    id,
    name,
    description,
    module,
    permissionItems,
  }: Pick<
    RoleTemplateItem<ID, Name, Description, ModuleID, ModuleName>,
    'id' | 'name' | 'module' | 'permissionItems'
  > &
    Partial<
      Pick<
        RoleTemplateItem<ID, Name, Description, ModuleID, ModuleName>,
        'description'
      >
    >) {
    super(id)
    this.name = name
    this.description = description
    this.module = module
    this.permissionItems = permissionItems
    this.permissions = permissionItems.map(({ id }) => id.toString())
  }
}
